import { CalendarCheck, Clock, MapPin } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Address, BusinessHours, MapsEmbedUrl, MapsUrl } from "@/data/SiteContent";

export default function Location() {
  return (
    <section id="ubicacion" className="scroll-mt-20 bg-white py-20 lg:py-28">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-4 sm:px-8 lg:grid-cols-2 lg:px-16">
        <Reveal>
          <p className="text-xs font-medium uppercase tracking-[0.3em] text-gold-dark">
            Ubicación y horarios
          </p>
          <h2 className="mt-4 font-serif text-3xl tracking-tight text-ink sm:text-4xl">
            Visítenos
          </h2>

          <div className="mt-8 flex gap-4">
            <MapPin className="mt-1 h-5 w-5 shrink-0 text-gold-dark" aria-hidden="true" />
            <div>
              <h3 className="font-serif text-lg text-ink">Dirección</h3>
              <p className="mt-2 text-sm leading-relaxed text-ash">{Address}</p>
              <a
                href={MapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="google-maps-button"
                className="mt-4 inline-block border border-gold px-6 py-2.5 text-sm font-medium text-gold-dark transition-colors duration-300 hover:bg-gold hover:text-ink"
              >
                Cómo llegar
              </a>
            </div>
          </div>

          <div
            className="mt-10 flex gap-4"
            data-testid="location-hours-card"
          >
            <Clock className="mt-1 h-5 w-5 shrink-0 text-gold-dark" aria-hidden="true" />
            <div>
              <h3 className="font-serif text-lg text-ink">Horario de atención</h3>
              <dl className="mt-3 space-y-2 text-sm text-ash">
                {BusinessHours.map((pSchedule) => (
                  <div key={pSchedule.Days} className="flex gap-3">
                    <dt className="w-32 font-medium text-ink">{pSchedule.Days}</dt>
                    <dd>{pSchedule.Hours}</dd>
                  </div>
                ))}
              </dl>
              <p className="mt-5 inline-flex items-center gap-2 border border-gold/50 bg-cream px-4 py-2.5 text-sm font-medium text-gold-dark">
                <CalendarCheck className="h-4 w-4" aria-hidden="true" />
                Atención con cita previa.
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal Delay={150}>
          <div className="overflow-hidden border border-gold/30 shadow-lg">
            <iframe
              src={MapsEmbedUrl}
              title="Mapa de ubicación de Grupo Jurídico San Juan en Poás, Alajuela"
              data-testid="google-maps-embed"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
              className="h-80 w-full lg:h-[26rem]"
            />
          </div>
          <p className="mt-3 text-sm text-ash">
            Poás, Alajuela · Costa Rica —{" "}
            <a
              href={MapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gold-dark underline-offset-4 transition-colors duration-300 hover:underline"
            >
              Ver ubicación en Google Maps
            </a>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
